module.exports = __webpack_public_path__ + "static/img/1028_small.adb61a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1028_small.png
// module id = TuGx
// module chunks = 1